import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { LoginService } from './login.service';
import { environment } from '../../../../environments/environment';
import { User } from '../models/user';



import { LoggerService } from '../../../services/logger/logger.service';
import { ConnectionService } from '../../../services/connection/connection.service';

@Injectable()
export class LoginOdooService extends LoginService {

  constructor(
    private connectionService: ConnectionService,
    private logger: LoggerService
  ) {
    super();
  }

  login(login: string, password: string, database?: string): Observable<User> {
    const url = '/web/session/authenticate';
    const loginData = {
      db: database || this.databaseName,
      login: login || '',
      password: password || ''
    };

    return this.connectionService.sendJsonPostRequest(url, loginData)
      .pipe(map((data: any) => {
        if (data && data.uid) {
          this.logger.info(`LoginOdooService: login ${data.username}`);
          return new User({ id: data.uid, username: data.username, session_id: data.session_id });
        } else {
          this.logger.warn(`LoginOdooService: failed to login.`);
          return null;
        }
      }));
  }

  logout(): Observable<any> {
    this.logger.info(`LoginOdooService: logout`);
    return this.connectionService.sendGetRequest('/web/session/logout');
  }

  resetPassword(email: string): Observable<string> {
    this.logger.info(`LoginOdooService: resetPassword ${email}`);
    const url = '/store/reset_password_request';
    return this.connectionService.sendJsonPostRequest(url, { login: email })
      .pipe(map((data: any) => {
        return data ? data.message : null;
      }));
  }

  resetPasswordByToken(token: string, password: string, confirmPassword: string): Observable<string> {
    this.logger.info(`LoginOdooService: resetPasswordByToken ${token}`);
    const url = '/store/reset_password_by_token';
    return this.connectionService.sendJsonPostRequest(url, { token: token, password: password, confirm_password: confirmPassword })
      .pipe(map((data: any) => {
        return data ? data.message : null;
      }));
  }

  get loggedInUser(): Observable<User> {
    if (!this.connectionService.isAuthorizationTokenExist) {
      this.logger.info(`LoginOdooService: loggedInUser authorization token is not exist.`);
      return of(null);
    }

    const url = '/web/session/get_session_info';
    return this.connectionService.sendJsonPostRequest(url)
      .pipe(map((data: any) => {
        if (data && data.uid) {
          this.logger.info(`LoginOdooService: loggedInUser ${data.username}`);
          return new User({ id: data.uid, username: data.username });
        } else {
          this.logger.info(`LoginOdooService: loggedInUser failed to get logged in user data.`);
          return null;
        }
      }));
  }

  private get databaseName() {
    return environment.odooDatabaseName || '';
  }

  changePassword(password: string, newPassword: string): Observable<boolean> {
    if (!password || !newPassword) {
      this.logger.error(`PartnerOdooService: changePassword. Parameter password or newPassword is undefined.`);
      throw new Error('Parameter "password" or "newPassword" is undefined.');
    }

    const url = '/web/session/change_password';
    const paramList = {
      fields: [
        { name: 'old_pwd', value: password },
        { name: 'new_password', value: newPassword },
        { name: 'confirm_pwd', value: newPassword }
      ]
    };
    return this.connectionService.sendJsonPostRequest(url, paramList)
      .pipe(map((result) => {
        if (result && !result.error) {
          this.logger.info(`LoginOdooService: changePassword ${result}`);
          return true;
        } else {
          this.logger.info(`LoginOdooService: changePassword. Failed. ${result.error}`);
          return false;
        }
      }));
  }
}
